import { ContractTaxonomyFragment } from 'generated/resources/graphql'

import type Employee from 'modules/employees/store/models/Employee'
import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'
import type { EmployeeEstimatedPeriodBaseSalary } from 'modules/payroll_bundle/hooks/useEmployeeEstimatedPeriodBaseSalary'
import Item from 'modules/payroll_bundle/components/Supplements/components/Item'

interface SupplementTableRowCellProps {
  employee: Employee | undefined
  isLast: boolean
  supplementsStore: SupplementsFormStore
  loading: boolean
  taxonomies: ContractTaxonomyFragment[]
  estimatedSalary?: EmployeeEstimatedPeriodBaseSalary
  itemToHighlight?: { employeeId?: number; supplementId?: number } | null
  shouldScrollIntoView?: boolean | null
  employeeExpansionState?: Record<string, boolean>
  toggleEmployeeExpansion?: (id: string) => void
  toggleTaxonomyCreationModal: (value: boolean) => void
}

/**
 * Renders the supplement row content (Item) for one employee inside a
 * DataCollection table cell. Used so the same data as the old table is
 * shown in the DataCollection table.
 */
export function SupplementTableRowCell({
  employee,
  isLast,
  supplementsStore,
  loading,
  taxonomies,
  estimatedSalary,
  itemToHighlight,
  shouldScrollIntoView,
  employeeExpansionState,
  toggleEmployeeExpansion,
  toggleTaxonomyCreationModal,
}: SupplementTableRowCellProps) {
  if (!employee) return null

  return (
    <Item
      employee={employee}
      isLast={isLast}
      estimatedSalary={estimatedSalary}
      supplementsStore={supplementsStore}
      loading={loading}
      taxonomies={taxonomies}
      itemToHighlight={itemToHighlight}
      shouldScrollIntoView={shouldScrollIntoView}
      employeeExpansionState={employeeExpansionState}
      toggleEmployeeExpansion={toggleEmployeeExpansion}
      toggleTaxonomyCreationModal={toggleTaxonomyCreationModal}
    />
  )
}
